<dsh-home>
    <dsh-sections *ngIf="bootstrapped$ | async"></dsh-sections>
</dsh-home>
